import React, { useState } from "react";
import PrimaryButton from "./PrimaryButton";
import Team1 from "../assets/images/team1.jpg";
import Team2 from "../assets/images/team2.png";
import FB from "../assets/icons/fb.png";
import Insta from "../assets/icons/insta.png";
import Twitter from "../assets/icons/twitter.png";
import YouTube from "../assets/icons/utube.png";

const teamMembers = [
  {
    name: "Stella Nsong",
    title: "Chief Caregiving Officer & Global Care Navigator",
    description:
      "Stella Nsong is an award-winning nurse entrepreneur, best selling author, elder care strategist, and global health futurist featured on CNN, CNBC, and FOX News. She is popularly known as The Elder Care Cliff Expert. She is redefining how the world approaches aging, wellness, and cross-border family care. As Co-Founder of VeriMED, she pioneers a new model of home health and geriatric wellness—bridging care between families abroad and their loved ones in Cameroon. Through VeriMED, Stella champions a seamless model of medical and wellness support for aging parents in Cameroon.",
    image: Team2,
    social: [FB, Twitter, Insta, YouTube],
  },
  {
    name: "Dr. Stanley-Ivo Foy",
    title: "Co-Founder & Chief Medical Officer",
    description:
      "Dr. Stanley-Ivo Foy is one of Cameroon’s most gifted medical minds — a physician whose academic brilliance and clinical mastery have set him apart since his earliest training. Driven by relentless curiosity, daily study, and a deep commitment to clinical excellence. He has performed complex surgeries in Kumba that many believed were impossible to accomplish locally, let alone in Cameroon, expanding what quality care can look like in underserved environments. Known for his compassion, responsiveness, and calm clinical confidence, Dr. Foy blends rare intelligence with a heart for service. As Co-Founder of VeriMED, he partners with Stella Nsong to transform healthcare experiences for families in Cameroon. Their shared journeys — marked by the loss of loved ones to preventable medical failures — fuel their mission to deliver safe, modern, dignified, and dependable care that families can trust. Dr. Foy stands at the forefront of a new era in community-based and concierge-style medical service in Cameroon, shaping health outcomes with skill, innovation, and unwavering dedication",
    image: Team1,
    social: [FB, Twitter, Insta, YouTube],
  },
];

export default function TeamCarousel() {
  const [index, setIndex] = useState(0);

  const nextSlide = () => setIndex((prev) => (prev + 1) % teamMembers.length);
  const prevSlide = () =>
    setIndex((prev) => (prev - 1 + teamMembers.length) % teamMembers.length);

  return (
    <div className="team_container">
      {/* Header */}
      <div className="team_header">
        <h2 className="team_title">Our Team</h2>
        <PrimaryButton label="View More Doctors" onClick={() => {}} />
      </div>

      {/* Cards */}
      <div className="team_cardsContainer">
        {teamMembers.slice(index, index + 2).map((member, i) => (
          <div key={i} className="team_card">
            <img
              src={member.image}
              alt={member.name}
              className="team_cardImage"
            />

            <div className="team_cardContent">
              <h3 className="team_cardName">{member.name}</h3>
              <p className="team_cardTitle">{member.title}</p>
              <p className="team_cardDesc">{member.description}</p>
              <div className="team_socialIcons">
                {member.social.map((icon, j) => (
                  <img
                    key={j}
                    src={icon}
                    alt="social"
                    className="team_socialIcon"
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Dots */}
      <div className="team_dots">
        {Array.from({ length: Math.ceil(teamMembers.length / 2) }).map(
          (_, dotIdx) => (
            <div
              key={dotIdx}
              onClick={() => setIndex(dotIdx * 2)}
              className={`team_dot ${index / 2 === dotIdx ? "active" : ""}`}
            ></div>
          )
        )}
      </div>
    </div>
  );
}
